import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Hide the instant-paint splash loader once React has mounted and painted.
// Keeps a short minimum display so the reveal feels smooth, not flickery.
const PAGE_LOADED_AT = window.__BOOST_LOAD_START || Date.now();
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    const elapsed = Date.now() - PAGE_LOADED_AT;
    const wait = Math.max(0, 700 - elapsed);
    setTimeout(() => window.__hideBoostLoader && window.__hideBoostLoader(), wait);
  });
});
